import { decodeBase64UrlToString } from './decodeBase64UrlToString.js';

export const parsePieveLinkRecipientToken = (token) => {
  const decoded = decodeBase64UrlToString(String(token || '').trim());

  if (!decoded) {
    return null;
  }

  let payload = null;

  try {
    payload = JSON.parse(decoded);
  } catch {
    return null;
  }

  const companyId = String(payload?.companyId || '').trim();
  const userId = String(payload?.userId || '').trim();

  if (!companyId) {
    return null;
  }

  return { companyId, userId: userId || null };
};
